const templatesListVariables = {
  search: undefined,
  type: undefined,
  orderBy: 'createdAt_DESC',
  status: 'PENDING'
}

export default templatesListVariables
